import { getPreset } from 'common/api/v1/systems';

import {
    FETCH_ITEM,
    FETCH_ITEM_FAILURE,
    FETCH_ITEM_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

import prepareUpdate from './prepareUpdate';

export default (id) => (dispatch) => {
    dispatch(actions[FETCH_ITEM]());

    getPreset(id)
        .then((response) => {
            dispatch(actions[FETCH_ITEM_SUCCESS](response?.data?.data));
            dispatch(prepareUpdate(id, response?.data?.data));
        })
        .catch((error) => {
            dispatch(actions[FETCH_ITEM_FAILURE](error));
        });
};
